import { FieldValues, UseFormSetValue } from 'react-hook-form';
import { GenderEnum, IDefaultPharmaceuticalValueRegistrationFormData, IRegistrationFormData } from '../contracts';
import { GetPharmaceutical, SignupPharmaceuticalParams, UpdatePharmaceuticalParams } from '../contracts/signupInterface';
import envConfig from '../../../../config/environment-config';

function formatCPF(cpf: string) {
  const clearCpf = cpf.replace(/\D/g, '');
  const formattedCpf = clearCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  return formattedCpf;
}

function formatData(ISOData: string) {
  const data = new Date(ISOData);
  const dia = data.getUTCDate().toString().padStart(2, '0');
  const mes = (data.getUTCMonth() + 1).toString().padStart(2, '0');
  const ano = data.getUTCFullYear();

  return `${dia}/${mes}/${ano}`;
}

function formatCellphone(cellphone: string) {
  const ddd = cellphone.slice(0, 2);
  const formatedCellphone = cellphone.slice(2).replace(/(\d{1})(\d{4})(\d{4})/, '$1 $2-$3');

  return {
    ddd,
    formatedCellphone
  }
}

function unformattedCellphone(
  ddd: string,
  cellphone: string,
): string {
  return `${ddd}${cellphone}`.replace(/\D/g, '');
}

export function handlePharmaceuticalDefaultValueData(
  PharmaceuticalData?: GetPharmaceutical,
): IDefaultPharmaceuticalValueRegistrationFormData | undefined {
  if (!PharmaceuticalData) return undefined;

  return {
    name: PharmaceuticalData.name,
    cpf: formatCPF(PharmaceuticalData.cpf),
    crf: PharmaceuticalData.crf,
    crfUf: PharmaceuticalData.crfUf,
    birthDate: formatData(PharmaceuticalData.birthdate),
    gender: PharmaceuticalData.gender as GenderEnum,
    DDD: formatCellphone(PharmaceuticalData.cellphone).ddd,
    phone: formatCellphone(PharmaceuticalData.cellphone).formatedCellphone,
    email: PharmaceuticalData.email,
  };
}

export function setPharmaceuticalDefaultValues(
  defaultValue: IRegistrationFormData,
  setValue: UseFormSetValue<FieldValues>,
) {
  if (defaultValue) {
    setValue('cpf', defaultValue?.cpf);
    setValue('crf', defaultValue?.crf);
    setValue('crfUf', defaultValue?.crfUf);
    setValue('birthDate', defaultValue?.birthDate);
    setValue('name', defaultValue?.name);
    setValue('gender', defaultValue?.gender);
    setValue('DDD', defaultValue?.DDD);
    setValue('phone', defaultValue?.phone);
    setValue('email', defaultValue?.email);
  }
}

export function preparePharmaceuticalCreateData(
  registrationFormData: any,
): SignupPharmaceuticalParams {
  return {
    code: envConfig.originCode,
    type: 'type',
    programId: envConfig.boehringerProgramCode,
    user: {
      cpf: registrationFormData.cpf.replace(/\D/g, ''),
      name: registrationFormData.name
        .trim()
        .replace(/\s+/g, ' '),
      email: registrationFormData.email
        .trim()
        .toLowerCase(),
      password: registrationFormData.password,
      crf: registrationFormData.crf.trim(),
      crfUf: registrationFormData.crfUf,
      birthdate: registrationFormData.birthDate,
      cellphone: unformattedCellphone(
        registrationFormData.DDD,
        registrationFormData.phone,
      ),
      gender: registrationFormData.gender,
    },
  };
}

export function preparePharmaceuticalUpdateData(
  registrationFormData: IDefaultPharmaceuticalValueRegistrationFormData,
  healthPassportId: string,
): UpdatePharmaceuticalParams {
  return {
    code: envConfig.originCode,
    type: 'type',
    programId: envConfig.boehringerProgramCode,
    healthPassportId,
    user: {
      name: registrationFormData.name,
      cpf: registrationFormData.cpf.replace(/[^a-zA-Z0-9\s]/g, ''),
      crf: registrationFormData.crf,
      crfUf: registrationFormData.crfUf,
      birthDate: registrationFormData.birthDate ?? '',
      gender: registrationFormData.gender,
      cellphone: unformattedCellphone(registrationFormData.DDD, registrationFormData.phone),
      email: registrationFormData.email,
      password: registrationFormData.password,
      confirmPassword: registrationFormData.confirmPassword,
      oldPassword: registrationFormData.oldPassword,
    },
  };
}